import React from 'react';

import styles from './StatisticsRelationship.module.scss';
import { Col, Container, Row } from 'react-bootstrap';
import RelationshipCardPups from './RelationshipCards/RelationshipCardPups/RelationshipCardPups';
import RelationshipCardAvgLitterSize from './RelationshipCards/RelationshipCardAvgLitterSize/RelationshipCardAvgLitterSize';
import RelationshipCardAvgInbreeding from './RelationshipCards/RelationshipCardAvgInbreeding/RelationshipCardAvgInbreeding';
import RelationshipCardProportionInbreeding from './RelationshipCards/RelationshipCardProportionInbreeding/RelationshipCardProportionInbreeding';

function StatisticsRelationship(props: StatisticsRelationshipProps) {

    const [hasDataPups, setHasDataPups] = React.useState<boolean>(false);
    const [hasDataAvgLitterSize, setHasDataAvgLitterSize] = React.useState<boolean>(false);
    const [hasDataAvgInbreeding, setHasDataAvgInbreeding] = React.useState<boolean>(false);
    const [hasDataProportionInbreeding, setHasDataProportionInbreeding] = React.useState<boolean>(false);

    React.useEffect(() => {
        props.onDataLoaded?.(hasDataPups || hasDataAvgLitterSize || hasDataAvgInbreeding);
    }, [hasDataPups, hasDataAvgLitterSize, hasDataAvgInbreeding]);

    return (
        <div className={styles.statisticsrelationship}>
            <Container className={styles.container}>
                <Row className={styles.row}>
                    <Col
                        sm="12"
                        md="6"
                        className={styles.col}
                        style={{
                            display:
                                hasDataPups
                                ? "block" : "none"
                        }}
                    >
                        <RelationshipCardPups
                            onDataLoaded={(data) => {
                                if (data.length != 0) {
                                    setHasDataPups(true);
                                } else {
                                    setHasDataPups(false);
                                }
                            }}
                        />
                    </Col>
                    <Col
                        sm="12"
                        md="6"
                        className={styles.col}
                        style={{
                            display:
                                hasDataAvgLitterSize
                                ? "block" : "none"
                        }}
                    >
                        <RelationshipCardAvgLitterSize
                            onDataLoaded={(data) => {
                                if (data.length != 0) {
                                    setHasDataAvgLitterSize(true);
                                } else {
                                    setHasDataAvgLitterSize(false);
                                }
                            }}
                        />
                    </Col>
                    <Col
                        sm="12"
                        md="6"
                        className={styles.col}
                        style={{
                            display:
                                hasDataAvgInbreeding
                                ? "block" : "none"
                        }}
                    >
                        <RelationshipCardAvgInbreeding
                            onDataLoaded={(data) => {
                                if (data.length != 0) {
                                    setHasDataAvgInbreeding(true);
                                } else {
                                    setHasDataAvgInbreeding(false);
                                }
                            }}
                        />
                    </Col>
                    <Col
                        sm="12"
                        md="6"
                        className={styles.col}
                        style={{
                            display:
                                hasDataProportionInbreeding
                                ? "block" : "none"
                        }}
                    >
                        <RelationshipCardProportionInbreeding
                            onDataLoaded={(data) => {
                                if (data.length != 0) {
                                    setHasDataProportionInbreeding(true);
                                } else {
                                    setHasDataProportionInbreeding(false);
                                }
                            }}
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

class StatisticsRelationshipProps {
    onDataLoaded?: (hasData: boolean) => void;
}

export default StatisticsRelationship;